import { LOGO_URL, BRAND_NAME } from "../lib/brand";

export function Logo({ className = "h-9 w-9", showText = true, textClass = "text-lg", "data-testid": testId = "brand-logo" }) {
    return (
        <a href="/" className="inline-flex items-center gap-3" data-testid={testId}>
            <img src={LOGO_URL} alt={BRAND_NAME} className={className} />
            {showText && (
                <span className={`font-display font-extrabold tracking-tight ${textClass}`}>
                    <span className="text-[hsl(217,91%,45%)] dark:text-[hsl(217,91%,60%)]">Sp</span>
                    <span className="text-foreground">Link</span>
                    <span className="text-[hsl(100,76%,42%)] dark:text-[hsl(100,70%,55%)]">.pro</span>
                </span>
            )}
        </a>
    );
}

export default Logo;
